import moment from "moment";

/**
 * Formats a date string in MM/DD/YYYY format with proper century handling
 * @param dateString - The date string to format (MM/DD/YY or MM/DD/YYYY)
 * @returns Formatted date string or original if invalid
 */
export function formattedDateString(dateString: string) {
	const dateRegex = /^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2}|[0-9]{4})$/;
	if (dateRegex.test(dateString)) {
		let formattedDateString: string;
		const centuryLimit = parseInt(moment().format("YY")) + 7;
		const dateParts = dateString.split("/");
		const yearPadding =
			dateParts[2].length === 2 && parseInt(dateParts[2]) > centuryLimit ? 19 : 20;
		let month = dateParts[0].length === 1 ? `0${dateParts[0]}` : dateParts[0];
		let day = dateParts[1].length === 1 ? `0${dateParts[1]}` : dateParts[1];
		let year =
			dateParts[2].length === 2 ? `${yearPadding}${dateParts[2]}` : dateParts[2];
		formattedDateString = `${month}/${day}/${year}`;
		if (formattedDateString) {
			return formattedDateString;
		}
	}
	return dateString;
}
